import React from "react";
import { Box, CircularProgress, Grid, styled } from "@mui/material";

export const PageLoader = () => {
  return (
    <StyledBox>
      <CircularProgress />
    </StyledBox>
  );
};

const StyledBox = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
